import React from 'react';
import './main.less';

import { Field, reduxForm } from 'redux-form';

import Textarea from '../../../../../shared/form-elements/textarea';

function Main({ intl, can, handleSubmit }) {
	return (
		<form
			className='profile__description-form'
			onSubmit={handleSubmit}
		>
			<div className='profile__description-field'>
				<Field
					name='description'
					component={Textarea}
					placeholder={intl('Description')}
					showLabel={false}
					disabled={!can('edit')}
				/>
			</div>
			{can('edit') && (
				<button className='ui-btn ui-btn-primary'>
					{intl('Save')}
				</button>
			)}
		</form>
	);
}

export default reduxForm({ form: 'affiliateProfileDescriptionForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/description/main.js